import React from 'react';

import HomepageThumbnail from '@/assets/home/homepage-social-media-thumbnail.jpg';
import FacebookIcon from '@/components/icons/Facebook.svg';
import PinterestIcon from '@/components/icons/Pinterest.svg';
import TwitterIcon from '@/components/icons/Twitter.svg';

interface ISocialShareProps {
  label?: string;
  url: string;
  title: string;
  type?: string;
  className?: string;
  heroImage?: string;
}
const SocialShare: React.FC<ISocialShareProps> = ({
  label,
  url,
  title,
  type,
  className,
  heroImage,
}) => {
  const pinterestImage = heroImage || `${process.env.hostApp}${HomepageThumbnail.src}`;

  return (
    <div className={`flex items-center pb-4 ${className}`}>
      {label && <h4 className="pr-4 !mb-0">{label}</h4>}
      <div className="pr-2">
        <a
          href={`https://www.facebook.com/sharer.php?u=${encodeURI(url)}%3Fcam%3D756%26subcam%3D${
            type || ''
          }`}
          target="_blank"
          aria-label="Facebook Share"
          rel="noopener noreferrer">
          <FacebookIcon />
        </a>
      </div>

      <div className="pr-2">
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURI(url)}%3Fcam%3D756%26subcam%3D${
            type || ''
          }&amp;text=${title}&amp;via=Outdoorsy`}
          target="_blank"
          aria-label="Twitter Share"
          rel="noopener noreferrer">
          <TwitterIcon />
        </a>
      </div>

      <div className="pr-2">
        <a
          href={`http://pinterest.com/pin/create/link/?url=${encodeURI(url)}%3Fcam%3D756%26subcam%3D${
            type || ''
          }&media=${pinterestImage}&description=${encodeURIComponent(title)}`}
          target="_blank"
          aria-label="Pinterest Share"
          rel="noopener noreferrer">
          <PinterestIcon />
        </a>
      </div>
    </div>
  );
};

export default SocialShare;
